(() => {
  const selector = '.valmonti-collection, .valmonti-search--results';

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach((collection) => {
      if (collection.dataset.valmontiInitialized === 'true') return;
      collection.dataset.valmontiInitialized = 'true';

      const disclosures = [...collection.querySelectorAll('.valmonti-collection__filter-details, .valmonti-collection__sort')];
      disclosures.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          disclosures.forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        });
        details.querySelectorAll('[data-valmonti-details-close]').forEach((button) => {
          button.addEventListener('click', () => details.removeAttribute('open'));
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        disclosures.find((details) => details.open)?.removeAttribute('open');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
